import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EcomItemOptionsDto } from '../shared/dto/ecom-item-options.dto';
import { EcomItemOptionTypesDto } from '../shared/dto/ecom-item-options-type.dto';

@Component({
  selector: 'wl-ecom-item-edit-options',
  templateUrl: './ecom-item-edit-options.component.html',
  styleUrls: ['./ecom-item-edit-options.component.less'],
    standalone: false
})
export class EComItemEditOptionsComponent implements OnChanges {
  @Input() ecomOptionType: EcomItemOptionTypesDto;
  selected: boolean;
  holding: EcomItemOptionsDto[];
  component: {};

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ecomOptionType) {
      this.selected = !!this.ecomOptionType.EComItemOptions;
    }
  }

  reorder() {
    for (let i = 0; i < this.ecomOptionType.EComItemOptions.length; i++) {
      this.ecomOptionType.EComItemOptions[i].SortOrder = i;
    }
  }

  typeCheckedChanged() {
    if (!this.selected) {
      this.holding = [...this.ecomOptionType.EComItemOptions];
      this.ecomOptionType.EComItemOptions.splice(0, this.ecomOptionType.EComItemOptions.length);
    } else {
      if (this.holding?.length) {
        this.ecomOptionType.EComItemOptions.push(...this.holding);
      }
    }
  }

  addOption(typeId: number) {
    if (!this.ecomOptionType.EComItemOptions) {
      this.ecomOptionType.EComItemOptions = [];
    }
    let maxSort = this.ecomOptionType.EComItemOptions?.reduce((x, y) => (x.SortOrder > y.SortOrder ? x : y), { SortOrder: 0 }).SortOrder;
    this.ecomOptionType.EComItemOptions.push({
      ItemOptionTypeId: typeId,
      SortOrder: maxSort + 1,
    } as EcomItemOptionsDto);
  }

  delete(itemOption: EcomItemOptionsDto) {
    let index = this.ecomOptionType.EComItemOptions.indexOf(itemOption);
    this.ecomOptionType.EComItemOptions.splice(index, 1);
  }
}
